/*!
 * send
 * Copyright(c) 2012 TJ Holowaychuk
 * Copyright(c) 2014-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

'use strict'

/**
 * Module dependencies.
 * @private
 */
const isUtf8MimeType = require('./lib/isUtf8MimeType').isUtf8MimeType
const mime = require('mime')
const send = require('./lib/send').send

/**
 * Module exports.
 * @public
 */

module.exports = send
module.exports.default = send
module.exports.send = send

module.exports.isUtf8MimeType = isUtf8MimeType
module.exports.mime = mime
